import React from 'react'
import { Link } from 'gatsby'

import Layout from '../components/layout'
import Image from './images/contact-us.jpg'
import SEO from '../components/seo'

const IndexPage = () => (
  <Layout>
    <SEO title="Contact Us" keywords={[]} />
    <div id="main" role="main">
      {' '}
      <div id="content" style={{ display: 'inline-block' }}>
        <h1 className="page-title">Contact Us</h1>
        <p>
          If you would like to speak with us, please use the Contact Form. We
          will be happy to review your situation with you at no cost and no
          obligation. Your information will not be shared outside of{' '}
          <em>Gómez &amp; Associates.</em>
        </p>
        <div id="content-left" className="float-left">
          <code>
            <div className="wpcf7" id="wpcf7-f275-p15-o1">
              <p />
              <form
                action="http://gomezandassociates.com/contact-us#wpcf7-f275-p15-o1"
                method="post"
                className="wpcf7-form"
                style={{ display: 'none' }}
              >
                <div style={{ display: 'none' }}>
                  <input type="hidden" name="_wpcf7" defaultValue={275} />
                  <input
                    type="hidden"
                    name="_wpcf7_version"
                    defaultValue="3.0.2.1"
                  />
                  <input
                    type="hidden"
                    name="_wpcf7_unit_tag"
                    defaultValue="wpcf7-f275-p15-o1"
                  />
                </div>
                <p>
                  Your Name (required)
                  <br />
                  <span className="wpcf7-form-control-wrap your-name">
                    <input
                      type="text"
                      name="your-name"
                      defaultValue
                      className="wpcf7-text wpcf7-validates-as-required"
                      size={40}
                    />
                  </span>{' '}
                </p>
                <p>
                  Your Email (required)
                  <br />
                  <span className="wpcf7-form-control-wrap your-email">
                    <input
                      type="text"
                      name="your-email"
                      defaultValue
                      className="wpcf7-text wpcf7-validates-as-email wpcf7-validates-as-required"
                      size={40}
                    />
                  </span>{' '}
                </p>
                <p>
                  Subject
                  <br />
                  <span className="wpcf7-form-control-wrap your-subject">
                    <input
                      type="text"
                      name="your-subject"
                      defaultValue
                      className="wpcf7-text"
                      size={40}
                    />
                  </span>{' '}
                </p>
                <p>
                  Your Message
                  <br />
                  <span className="wpcf7-form-control-wrap your-message">
                    <textarea
                      name="your-message"
                      cols={40}
                      rows={10}
                      defaultValue={''}
                    />
                  </span>{' '}
                </p>
                <p>
                  <input
                    type="submit"
                    defaultValue="Send Your Message"
                    className="wpcf7-submit"
                  />
                </p>
                <div className="wpcf7-response-output wpcf7-display-none" />
              </form>
            </div>
          </code>
        </div>
        <div id="content-left" className="float-left">
          <ul className="ul-contact float-left">
            <li>
              <em>Gómez &amp; Associates</em>
            </li>
            <li>14 E. Jefferson Street</li>
            <li>Colorado Springs, CO 80907</li>
            <li>719.447.4841 (O)</li>
            <li>719.659.0808 (M)</li>
            <li>
              <a href="mailto:info@gomezandassociates.com">
                info@gomezandassociates.com
              </a>
            </li>
          </ul>
          <p>&nbsp;</p>
          <div>
            <img
              className="alignright"
              style={{ float: 'right', marginRight: 0 }}
              title="Our Clients"
              src={Image}
              width={400}
            />
          </div>
        </div>
        <p>
          <br clear="both" />
        </p>
      </div>
    </div>
  </Layout>
)

export default IndexPage
